import { log } from "@/core/logger";
import { fetchWithAuth } from "@/utils/fetchWithAuth";
import { API_BASE_URL } from "./helpers";
import { ApiError } from "./ApiError";
import type { IBillingAPI } from "./billingApi";
import type { BillingSummaryResponse, OrgBillingSummaryResponse } from "@/types/Billing";

class RemoteBillingAPI implements IBillingAPI {
  async fetchMyBillingSummary(): Promise<BillingSummaryResponse> {
    try {
      const response = await fetchWithAuth(`${API_BASE_URL}/api/member/billing-summary`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      if (!response.ok) {
        // Carry the status so the UI can distinguish a deploy-gap 404 (frontend
        // live before the backend endpoint) from a genuine failure.
        throw new ApiError(response.status, `API error: ${response.status} ${response.statusText}`);
      }
      const json = await response.json();
      return json.data as BillingSummaryResponse;
    } catch (error) {
      log("remoteBillingApi", "Failed to fetch billing summary", error);
      throw error;
    }
  }

  async fetchOrganisationBillingSummary(orgId: string): Promise<OrgBillingSummaryResponse> {
    try {
      const response = await fetchWithAuth(`${API_BASE_URL}/api/organisations/${orgId}/billing-summary`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      if (!response.ok) {
        throw new ApiError(response.status, `API error: ${response.status} ${response.statusText}`);
      }
      const json = await response.json();
      return json.data as OrgBillingSummaryResponse;
    } catch (error) {
      log("remoteBillingApi", "Failed to fetch organisation billing summary", error);
      throw error;
    }
  }
}

export default RemoteBillingAPI;
